export default __webpack_public_path__ + "static/media/bunnies-mob.a084951f.png";